import HTTP from "@/http-common";
// import { Address } from "@/models/Address";

export const state = {
  addressResults: [],
  fullAddress: {},
  searchResultId: "",
  predictedAddresses: []
};

export const getters = {
  addressResults: state => {
    return state.addressResults;
  },
  fullAddress: state => {
    return state.fullAddress;
  },
  searchResultId: state => {
    return state.searchResultId;
  },
  predictedAddresses: state => {
    return state.predictedAddresses;
  }
};

export const mutations = {
  SET_ADDRESS_RESULTS(state, results) {
    state.addressResults = results;
  },
  SET_FULL_ADDRESS(state, result) {
    state.fullAddress = result;
  },
  RESET_FULL_ADDRESS(state) {
    state.fullAddress = {};
  },
  SET_SEARCH_RESULT_ID(state, id) {
    state.searchResultId = id;
  },
  RESET_ADDRESS_RESULTS(state) {
    state.addressResults = [];
  },
  SET_PREDICTED_ADDRESSES(state, result) {
    state.predictedAddresses = result;
  }
};

export const actions = {
  setSearchResultId({ commit }, id) {
    commit("SET_SEARCH_RESULT_ID", id);
  },
  resetFullAddress({ commit }) {
    commit("RESET_FULL_ADDRESS");
  },
  async getFullAddress({ dispatch, commit, state }) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.get(
        `OptusNBN/GetFullAddress/${state.searchResultId}`
      );
      commit("SET_FULL_ADDRESS", result.data);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getOrderAddress({ dispatch }, address) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.get(`OptusNBN/GetOrderAddress/${address}`);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async searchAddress({ dispatch, commit }, streetAddress) {
    try {
      if (streetAddress != null && streetAddress.length >= 5) {
        let address = await HTTP.post("OptusNBN/ValidateAddress", {
          country: "AU",
          formatted_address: streetAddress,
          include_paf: true,
          include_listing: true,
          listing_type: "both"
        });
        commit("SET_ADDRESS_RESULTS", address.data.data.results);
        return Promise.resolve(address.data.data.results);
      }
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  setAddressResult({ commit }, data) {
    commit("SET_ADDRESS_RESULTS", data);
  },
  // completeAddress({ commit, state }, e) {
  //   debugger;
  //   var match = state.addressResults.filter(x => x.formatted_address === e);
  //   if (match.length > 0) {
  //     var splitStreetAddress = e.split(" ");
  //     let addr = new Address();
  //     addr.suburb = match[0].suburb;
  //     addr.state = splitStreetAddress[splitStreetAddress.length - 2];
  //     addr.postCode = match[0].postcode;
  //     addr.streetAddress = e.substring(0, e.indexOf(","));
  //     commit("SET_ADDRESS_RESULTS", []);
  //     return addr;
  //   }
  //   return null;
  // },
  async createTemplatedEmail({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/SendEmail", payload);
      if (result.data.success) {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: "Email sent!", color: "success" },
          { root: true }
        );
        dispatch("processLoader/setProcessInactive", {}, { root: true });
      } else {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: "Failed", color: "error" },
          { root: true }
        );
        dispatch("processLoader/setProcessInactive", {}, { root: true });
      }
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async createSupportTicket({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post(`OptusNBN/CreateSupportTicket`, payload);

      if (result.data.success === true) {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: "Ticket submitted!", color: "success" },
          { root: true }
        );
        dispatch("processLoader/setProcessInactive", {}, { root: true });
      } else {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: "Failed", color: "error" },
          { root: true }
        );
        dispatch("processLoader/setProcessInactive", {}, { root: true });
      }
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },

  resetAddressResults({ commit }) {
    commit("RESET_ADDRESS_RESULTS");
  },

  async getPredictAddresses({ dispatch, commit }, payload) {
    try {
      let result = await HTTP.get(`OptusNBN/GetPredictAddresses/${payload}`);
      commit("SET_PREDICTED_ADDRESSES", result.data.suggest);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },

  setPredictedAddress({ commit }, payload) {
    commit("SET_PREDICTED_ADDRESSES", payload);
  },

  async getVerifiedAddressDetail({ dispatch, commit, state }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      if (payload !== null) {
        let result = await HTTP.get(
          `OptusNBN/GetVerifiedAddressDetail/${payload.id}`
        );
        return Promise.resolve(result.data);
      } else {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: "Select address first!", color: "error" },
          { root: true }
        );
      }

      dispatch("processLoader/setProcessInactive", {}, { root: true });
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  }
};
